import {GameAvalancheReelsDropNewState} from 'src/avalanche/states/GameAvalancheReelsDropNewState';
import {AvalancheReelsModule} from '@fantasmagames/slot/src/modules/reels/avalanche/AvalancheReelsModule';
import {ReelConstants} from '@fantasmagames/slot/src/modules/reels/ReelConstants';
import {ReelsEvents} from '@fantasmagames/slot/src/modules/reels/spin/ReelsEvents';

export class TopGameAvalancheReelsDropNewState extends GameAvalancheReelsDropNewState {

	protected onAllReelsDroppedNew(): void {
		this.module.gotoState(AvalancheReelsModule.BASIC_STATE);
		this.emitDelayed(ReelsEvents.SPIN_ENDED);
	}

	protected dropNewSymbols(): void {
		this.module.timeUtils.oneFrameTimer(() => {
			this.view.dropNew(this.module.logic.getSpinResult().reels, ReelConstants.ROW_AMOUNT);
		});
	}
}



// WEBPACK FOOTER //
// ./src/topreels/states/TopGameAvalancheReelsDropNewState.ts